var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import api from 'app/core/api/api.js';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
const initialState = {
    data: [],
    count: 0,
    loading: false,
    error: null,
};
const removeDuplicates = (data, key) => {
    return [...new Map(data.map((x) => [key(x), x])).values()];
};
export const fetchFlags = createAsyncThunk('flags/fetchAll', (_a, _b) => __awaiter(void 0, [_a, _b], void 0, function* ({ params }, { fulfillWithValue, rejectWithValue }) {
    try {
        const res = yield api.flags.fetchAll(Object.assign(Object.assign({}, params.queries), { page: 1, page_size: 200 }));
        return fulfillWithValue(res.results);
    }
    catch (err) {
        return rejectWithValue(err);
    }
}));
export const fetchFlagsBySearch = createAsyncThunk('flags/fetchBySearch', (_a, _b) => __awaiter(void 0, [_a, _b], void 0, function* ({ queries, headers = {}, config = {} }, { fulfillWithValue, rejectWithValue }) {
    try {
        const { query, assetType, category, taskType } = queries, restQueries = __rest(queries, ["query", "assetType", "category", "taskType"]);
        const { formatMetaOnSearchResult } = config;
        const res = yield api.autocomplete(null, Object.assign({ model: 'flag', query, assetType, category, taskType }, restQueries), headers);
        return fulfillWithValue(res.results);
    }
    catch (err) {
        return rejectWithValue(err);
    }
}));
export const createFlag = createAsyncThunk('flags/create', (flag_1, _a) => __awaiter(void 0, [flag_1, _a], void 0, function* (flag, { fulfillWithValue, rejectWithValue }) {
    try {
        const res = yield api.flags.create(flag);
        console.log(res);
        return fulfillWithValue(res);
    }
    catch (err) {
        return rejectWithValue(err);
    }
}));
export const updateFlag = createAsyncThunk('flags/update', (flag_1, _a) => __awaiter(void 0, [flag_1, _a], void 0, function* (flag, { fulfillWithValue, rejectWithValue }) {
    try {
        const res = yield api.flags.update(flag);
        console.log(res);
        return fulfillWithValue(res);
    }
    catch (err) {
        return rejectWithValue(err);
    }
}));
export const deleteFlag = createAsyncThunk('flags/delete', (flagId_1, _a) => __awaiter(void 0, [flagId_1, _a], void 0, function* (flagId, { fulfillWithValue, rejectWithValue }) {
    try {
        yield api.flags.delete(flagId);
        return fulfillWithValue(flagId);
    }
    catch (err) {
        return rejectWithValue(err);
    }
}));
const { actions, reducer } = createSlice({
    name: 'reduxFlags',
    initialState,
    reducers: {
        setAllFlags: (state, { payload }) => {
            const t = [...state.data, ...payload];
            const newData = removeDuplicates(t, (it) => it.id);
            state.data = newData;
        },
        cleanFlags: (state) => {
            state.data = [];
            state.count = 0;
        },
        setFlagsAreLoading: (state, { payload }) => {
            state.loading = payload;
        },
        addFlagFromWS: (state, { payload }) => {
            const updatedPayload = Object.assign(Object.assign({}, payload), { id: payload.uuid });
            delete updatedPayload.uuid;
            const t = [...state.data, updatedPayload];
            const newData = removeDuplicates(t, (it) => it.id);
            state.data = newData;
        },
    },
    extraReducers: (builder) => {
        // FETCH FLAGS
        builder.addCase(fetchFlags.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(fetchFlags.fulfilled, (state, { payload }) => {
            const t = [...state.data, ...payload];
            const newData = removeDuplicates(t, (it) => it.id);
            state.data = newData;
            state.count = newData.length;
            state.loading = false;
        });
        builder.addCase(fetchFlags.rejected, (state, { payload }) => {
            state.error = payload;
            state.loading = false;
        });
        // FETCH FLAGS BY SEARCH
        builder.addCase(fetchFlagsBySearch.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(fetchFlagsBySearch.fulfilled, (state, { payload }) => {
            state.data = payload;
            state.count = payload.length;
            state.loading = false;
        });
        builder.addCase(fetchFlagsBySearch.rejected, (state, { payload }) => {
            state.error = payload;
            state.loading = false;
        });
        // CREATE FLAG
        builder.addCase(createFlag.pending, (state) => { });
        builder.addCase(createFlag.fulfilled, (state, { payload }) => {
            state.data = [...state.data, payload];
            state.count + 1;
        });
        builder.addCase(createFlag.rejected, (state, { payload }) => {
            state.error = payload;
        });
        // UPDATE FLAG
        builder.addCase(updateFlag.pending, (state) => { });
        builder.addCase(updateFlag.fulfilled, (state, { payload }) => {
            const newData = [
                ...state.data.map((flag) => {
                    if (flag.id === payload.id) {
                        return payload;
                    }
                    return flag;
                }),
            ];
            state.data = newData;
            state.count + 1;
        });
        builder.addCase(updateFlag.rejected, (state, { payload }) => {
            state.error = payload;
        });
        // DELETE FLAG
        builder.addCase(deleteFlag.pending, (state) => { });
        builder.addCase(deleteFlag.fulfilled, (state, { payload }) => {
            state.data = [...state.data.filter((flag) => flag.id !== payload)];
            state.count - 1;
        });
        builder.addCase(deleteFlag.rejected, (state, { payload }) => {
            state.error = payload;
        });
    },
});
export const { setAllFlags, cleanFlags, setFlagsAreLoading, addFlagFromWS } = actions;
export default reducer;
